import React from "react";
import {Delete, translate} from "admin-on-rest";
import PromoDataList from "./PromoDataList";
import PromoShowItem from "./PromoShowItem";
import PromoEditForm from "./PromoEditForm";
import PromoCreateForm from "./PromoCreateForm";

///////////////////// PROMO IMAGES DIMENSIONS /////////////////////
const dimensions = {
  large: {
    imageWidth: "600",
    imageHeight: "786"
  },
  small: {
    imageWidth: "504",
    imageHeight: "666"
  }
};

const imageLabel = {
  small: `${dimensions.small.imageWidth} x ${dimensions.small.imageHeight}`,
  large: `${dimensions.large.imageWidth} x ${dimensions.large.imageHeight}`
};

///////////////////// LIST ALL PROMOS /////////////////////
export const PromoList = props => <PromoDataList {...props} />;

///////////////////// SHOW GAME TIP /////////////////////
export const PromoShow = props => (
  <PromoShowItem {...props} dimensions={dimensions} imageLabel={imageLabel} />
);

///////////////////// UPDATE PROMO /////////////////////
export const PromoEdit = props => (
  <PromoEditForm {...props} dimensions={dimensions} imageLabel={imageLabel} />
);

///////////////////// CREATE NEW PROMO /////////////////////
export const PromoCreate = props => (
  <PromoCreateForm {...props} dimensions={dimensions} imageLabel={imageLabel} />
);

///////////////////// DELETE PROMO /////////////////////
const PromoDeleteTitleBase = ({record, translate}) => (
  <span>
    {translate("aor.action.delete")}
    &nbsp;
    {record && <img src={`${record.avatar}?size=25x25`} width="25" alt="" />}
    {record && `${record.name}`}
  </span>
);

const PromoDeleteTitle = translate(PromoDeleteTitleBase);

export const PromoDelete = props => (
  <Delete {...props} title={<PromoDeleteTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/Promos/index.js